import { createContext, useContext } from 'react';
import type { PostMeta } from '@/blog/types';

export interface BlogPostContextValue {
  /** Full raw MDX source of the current post (for AI context) */
  rawContent: string;
  /** Post metadata */
  meta: PostMeta;
}

export const BlogPostContext = createContext<BlogPostContextValue | null>(null);

/**
 * Returns the current blog post context.
 * Must be used inside a BlogPost render tree.
 */
export function useBlogPost(): BlogPostContextValue {
  const ctx = useContext(BlogPostContext);
  if (!ctx) {
    throw new Error(
      'useBlogPost must be used within a BlogPostContext.Provider',
    );
  }
  return ctx;
}
